import useAbility from '@/plugins/useAbility';
import { USER_ACTIONS } from '@/utils/const';
import { buildSidebarDestination } from '@/composables/sidebarNavigation.mjs';
export default {
  name: 'SidebarGroupsItem',
  props: {
    title: {
      type: String,
      required: true
    },
    icon: {
      type: String,
      required: true
    },
    children: {
      type: Array,
      required: true
    },
    showLock: {
      type: Boolean,
      default: false
    },
    id: {
      type: String,
      required: true
    },
    iconClass: {
      type: String,
      default: ''
    },
    viewBox: {
      type: String,
      default: '0 0 24 24'
    }
  },
  data() {
    return {
      collapse: false
    };
  },
  computed: {
    subIsActive() {
      return this.children.some(c => c.Action.Page == this.$route.name);
    },
    childrenAbilitySubjects() {
      return this.children.map(c => c.ability.subject);
    },
    lockedItem() {
      return this.childrenAbilitySubjects.some(s => !this.can(USER_ACTIONS.READ, s));
    },
    disabled() {
      return this.showLock && this.lockedItem;
    }
  },
  methods: {
    destination(item) {
      return buildSidebarDestination(item, this.$route, this.children);
    },
    can(action, subject) {
      return useAbility().can(action, subject);
    }
  },
  mounted() {
    this.collapse = this.subIsActive;
  },
  watch: {
    subIsActive(isActive) {
      if (isActive) this.collapse = true;
    }
  }
};